export default __webpack_public_path__ + "static/media/dog6.6ed38205.jpg";